import {
  actionGroups,
  entryPoints,
  eventActions,
  eventCategories,
  eventContents,
  eventLabels,
  events,
} from './constants'
import { sendInteractionGtm, setEntryPoint, toCd1 } from './helpers'
import { sendGtmEvent } from './sendGtmEvent'

type StoryEventContent = typeof eventContents[keyof typeof eventContents]

type StoryClickParams = {
  storyName: string
  eventContent: StoryEventContent
  setStoryEntry?: boolean
}

type StorySlideShowParams = {
  storyName: string
  value?: string
}

type StoryButtonClickParams = {
  storyName: string
  buttonLabel: string
  value?: string
  eventContent: StoryEventContent
}

// Клик на сторис
export const storyClickGtm = ({ storyName, eventContent, setStoryEntry }: StoryClickParams) => {
  if (setStoryEntry) {
    setEntryPoint(entryPoints.storis)
  }

  sendInteractionGtm({
    eventAction: eventActions.cardClick,
    eventLabel: eventLabels.storis,
    eventContent,
    CD1: { cardName: toCd1(storyName) },
  })
}

// Показ слайда сторис
export const storySlideShowGtm = ({ storyName, value }: StorySlideShowParams) =>
  sendGtmEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovayaStranica,
    eventAction: eventActions.cardShow,
    eventLabel: eventLabels.storis,
    eventValue: value ?? null,
    actionGroup: actionGroups.nonInteractions,
    CD1: { cardName: toCd1(storyName) },
  })

// Клик на кнопку внутри сторис
export const storyButtonClickGtm = ({ storyName, buttonLabel, value, eventContent }: StoryButtonClickParams) =>
  sendInteractionGtm({
    eventAction: eventActions.buttonClick,
    eventLabel: toCd1(buttonLabel),
    eventValue: value ?? null,
    eventContent,
    CD1: { cardName: toCd1(storyName) },
  })
